/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: { input: any; output: any; }
  /** A scalar that can represent any JSON value. */
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Activities = {
  __typename?: 'Activities';
  activity?: Maybe<Activity>;
  all: Array<Activity>;
};


export type ActivitiesActivityArgs = {
  id: Scalars['String']['input'];
};

export type ActivitiesMutation = {
  __typename?: 'ActivitiesMutation';
  add?: Maybe<Activity>;
  delete: Scalars['Boolean']['output'];
  edit?: Maybe<Activity>;
};


export type ActivitiesMutationAddArgs = {
  activity: ActivityInput;
};


export type ActivitiesMutationDeleteArgs = {
  activityId: Scalars['String']['input'];
};


export type ActivitiesMutationEditArgs = {
  activity: ActivityInput;
};

export type Activity = {
  __typename?: 'Activity';
  childWorkflowId?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inputs: Array<ActivityParameter>;
  name: Scalars['String']['output'];
  outputs: Array<ActivityParameter>;
};

export type ActivityInput = {
  childWorkflowId?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  inputs: Array<ActivityParameterInput>;
  name: Scalars['String']['input'];
  outputs: Array<ActivityParameterInput>;
};

export type ActivityParameter = {
  __typename?: 'ActivityParameter';
  name: Scalars['String']['output'];
  type: ActivityParameterType;
};

export type ActivityParameterInput = {
  name: Scalars['String']['input'];
  type: ActivityParameterType;
};

export enum ActivityParameterType {
  Context = 'CONTEXT',
  Supplementary = 'SUPPLEMENTARY',
  SupplementaryArray = 'SUPPLEMENTARY_ARRAY'
}

export enum AttributeLocation {
  Item = 'ITEM',
  Relationship = 'RELATIONSHIP'
}

export enum AttributeType {
  Collection = 'COLLECTION',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Float = 'FLOAT',
  Int = 'INT',
  Metadata = 'METADATA',
  Profile = 'PROFILE',
  String = 'STRING'
}

export enum AttributeUiType {
  Collection = 'COLLECTION',
  File = 'FILE',
  Image = 'IMAGE',
  Input = 'INPUT',
  Metadata = 'METADATA',
  Profile = 'PROFILE',
  Textarea = 'TEXTAREA'
}

export type AttributesFilterInput = {
  attributes: Array<Scalars['String']['input']>;
  childAttributes?: InputMaybe<AttributesFilterInput>;
};

export type BeginTransitionInput = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  restart?: InputMaybe<Scalars['Boolean']['input']>;
  stateId: Scalars['String']['input'];
  stateValid?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
  supplementaryId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  waitForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Bible = {
  __typename?: 'Bible';
  abbreviation: Scalars['String']['output'];
  abbreviationLocal: Scalars['String']['output'];
  book?: Maybe<BibleBook>;
  books: Array<BibleBook>;
  chapter?: Maybe<BibleChapter>;
  defaultVariant: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  find: Array<FindBibleResult>;
  languages: Array<BibleLanguage>;
  name: Scalars['String']['output'];
  nameLocal: Scalars['String']['output'];
  styles: Scalars['JSON']['output'];
  systemId: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};


export type BibleBookArgs = {
  usfm: Scalars['String']['input'];
};


export type BibleChapterArgs = {
  usfm: Scalars['String']['input'];
};


export type BibleFindArgs = {
  human: Scalars['String']['input'];
};

export type BibleBook = {
  __typename?: 'BibleBook';
  abbreviation: Scalars['String']['output'];
  chapters: Array<BibleChapter>;
  human: Scalars['String']['output'];
  nameLong: Scalars['String']['output'];
  nameShort: Scalars['String']['output'];
  usfm: Scalars['String']['output'];
};

export type BibleChapter = {
  __typename?: 'BibleChapter';
  component: Scalars['JSON']['output'];
  human: Scalars['String']['output'];
  reference: BibleReference;
  usfm: Scalars['String']['output'];
  verses: Array<BibleReference>;
};

export type BibleInput = {
  abbreviation: Scalars['String']['input'];
  abbreviationLocal: Scalars['String']['input'];
  books: Array<BookInput>;
  defaultVariant: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  language: BibleLanguageInput;
  name: Scalars['String']['input'];
  nameLocal: Scalars['String']['input'];
  styles: Array<StyleInput>;
  systemId: Scalars['String']['input'];
  variant: Scalars['String']['input'];
};

export type BibleLanguage = {
  __typename?: 'BibleLanguage';
  iso: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameLocal: Scalars['String']['output'];
  script: Scalars['String']['output'];
  scriptCode: Scalars['String']['output'];
  scriptDirection: Scalars['String']['output'];
};

export type BibleLanguageInput = {
  iso: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameLocal: Scalars['String']['input'];
  script: Scalars['String']['input'];
  scriptCode: Scalars['String']['input'];
  scriptDirection: Scalars['String']['input'];
};

export type BibleReference = {
  __typename?: 'BibleReference';
  human: Scalars['String']['output'];
  usfm: Scalars['String']['output'];
};

export type BookInput = {
  abbreviation: Scalars['String']['input'];
  chapters: Array<ChapterInput>;
  nameLong: Scalars['String']['input'];
  nameShort: Scalars['String']['input'];
  reference: ReferenceInput;
};

export type BreakInput = {
  style?: InputMaybe<StyleInput>;
};

export type CacheObject = {
  __typename?: 'CacheObject';
  name: Scalars['String']['output'];
};

export type CachesObject = {
  __typename?: 'CachesObject';
  caches: Array<CacheObject>;
};

export type Categories = {
  __typename?: 'Categories';
  all: Array<Category>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CategoryInput = {
  name: Scalars['String']['input'];
};

export type CategoryMutation = {
  __typename?: 'CategoryMutation';
  add: Category;
  delete: Scalars['Boolean']['output'];
  edit: Category;
};


export type CategoryMutationAddArgs = {
  category: CategoryInput;
};


export type CategoryMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type CategoryMutationEditArgs = {
  category: CategoryInput;
  id: Scalars['String']['input'];
};

export type ChapterInput = {
  component: ComponentInput;
  reference: ReferenceInput;
};

export type Collection = {
  __typename?: 'Collection';
  attributes?: Maybe<Scalars['JSON']['output']>;
  categories: Array<Category>;
  collections: Array<Collection>;
  collectionsCount: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  expandedMetadata: Array<Metadata>;
  expandedMetadataCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemAttributes?: Maybe<Scalars['JSON']['output']>;
  items: Array<CollectionItem>;
  itemsCount: Scalars['Int']['output'];
  labels: Array<Scalars['String']['output']>;
  metadata: Array<Metadata>;
  metadataCount: Scalars['Int']['output'];
  metadataRelationships: Array<CollectionMetadataRelationship>;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  ordering?: Maybe<Array<Ordering>>;
  parentCollections: Array<Collection>;
  permissions: Array<Permission>;
  public: Scalars['Boolean']['output'];
  publicList: Scalars['Boolean']['output'];
  publicSupplementary: Scalars['Boolean']['output'];
  ready?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  supplementary: Array<CollectionSupplementary>;
  systemAttributes?: Maybe<Scalars['JSON']['output']>;
  templateMetadata?: Maybe<Metadata>;
  traitIds: Array<Scalars['String']['output']>;
  type: CollectionType;
  workflow: CollectionWorkflow;
};


export type CollectionAttributesArgs = {
  filter?: InputMaybe<AttributesFilterInput>;
};


export type CollectionCollectionsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type CollectionEtagArgs = {
  addHeader: Scalars['Boolean']['input'];
};


export type CollectionExpandedMetadataArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type CollectionExpandedMetadataCountArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type CollectionItemsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type CollectionItemsCountArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type CollectionMetadataArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type CollectionParentCollectionsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type CollectionSupplementaryArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionChildInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  collection: CollectionInput;
};

export type CollectionInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  collectionType?: InputMaybe<CollectionType>;
  collections?: InputMaybe<Array<CollectionChildInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<MetadataChildInput>>;
  name: Scalars['String']['input'];
  ordering?: InputMaybe<Array<OrderingInput>>;
  parentCollectionId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CollectionWorkflowInput>;
  templateMetadataId?: InputMaybe<Scalars['String']['input']>;
  templateMetadataVersion?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollectionItem = Collection | Metadata;

export type CollectionMetadataRelationship = {
  __typename?: 'CollectionMetadataRelationship';
  attributes?: Maybe<Scalars['JSON']['output']>;
  metadata: Metadata;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type CollectionMetadataRelationshipInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionMutation = {
  __typename?: 'CollectionMutation';
  add: Collection;
  addBulk: Array<Collection>;
  addChildCollection: Collection;
  addChildMetadata: Collection;
  addMetadataRelationship: CollectionMetadataRelationship;
  addPermission: Permission;
  addSupplementary: CollectionSupplementary;
  delete: Scalars['Boolean']['output'];
  deleteMetadataRelationship: Scalars['Boolean']['output'];
  deletePermission: Permission;
  deleteSupplementary: Scalars['Boolean']['output'];
  edit: Collection;
  editMetadataRelationship: Scalars['Boolean']['output'];
  mergeCollectionAttributes: Scalars['Boolean']['output'];
  mergeCollectionItemAttributes: Scalars['Boolean']['output'];
  mergeMetadataItemAttributes: Scalars['Boolean']['output'];
  mergeMetadataRelationshipAttributes: Scalars['Boolean']['output'];
  permanentlyDelete: Scalars['Boolean']['output'];
  removeChildCollection: Collection;
  removeChildMetadata: Collection;
  setChildItemAttributes: Collection;
  setCollectionAttributes: Scalars['Boolean']['output'];
  setCollectionOrdering: Scalars['Boolean']['output'];
  setCollectionSystemAttributes: Scalars['Boolean']['output'];
  setPublic: Collection;
  setPublicList: Collection;
  setPublicSupplementary: Collection;
  setReady: Scalars['Boolean']['output'];
  setSupplementaryContents: Scalars['Boolean']['output'];
  setSupplementaryTextContents: Scalars['Boolean']['output'];
  setSupplementaryUploaded: Scalars['Boolean']['output'];
  setWorkflowState: Scalars['Boolean']['output'];
  setWorkflowStateComplete: Scalars['Boolean']['output'];
};


export type CollectionMutationAddArgs = {
  collection: CollectionInput;
  collectionItemAttributes?: InputMaybe<Scalars['JSON']['input']>;
};


export type CollectionMutationAddBulkArgs = {
  collections: Array<CollectionChildInput>;
};


export type CollectionMutationAddChildCollectionArgs = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  collectionId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type CollectionMutationAddChildMetadataArgs = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
};


export type CollectionMutationAddMetadataRelationshipArgs = {
  relationship: CollectionMetadataRelationshipInput;
};


export type CollectionMutationAddPermissionArgs = {
  permission: PermissionInput;
};


export type CollectionMutationAddSupplementaryArgs = {
  supplementary: CollectionSupplementaryInput;
};


export type CollectionMutationDeleteArgs = {
  id: Scalars['String']['input'];
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CollectionMutationDeleteMetadataRelationshipArgs = {
  id: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};


export type CollectionMutationDeletePermissionArgs = {
  permission: PermissionInput;
};


export type CollectionMutationDeleteSupplementaryArgs = {
  id: Scalars['String']['input'];
};


export type CollectionMutationEditArgs = {
  collection: CollectionInput;
  id: Scalars['String']['input'];
};


export type CollectionMutationEditMetadataRelationshipArgs = {
  relationship: CollectionMetadataRelationshipInput;
};


export type CollectionMutationMergeCollectionAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type CollectionMutationMergeCollectionItemAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};


export type CollectionMutationMergeMetadataItemAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};


export type CollectionMutationMergeMetadataRelationshipAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  collectionId: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};


export type CollectionMutationPermanentlyDeleteArgs = {
  collectionId: Scalars['String']['input'];
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CollectionMutationRemoveChildCollectionArgs = {
  collectionId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type CollectionMutationRemoveChildMetadataArgs = {
  id: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
};


export type CollectionMutationSetChildItemAttributesArgs = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  childCollectionId?: InputMaybe<Scalars['String']['input']>;
  childMetadataId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type CollectionMutationSetCollectionAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type CollectionMutationSetCollectionOrderingArgs = {
  id: Scalars['String']['input'];
  ordering: Scalars['JSON']['input'];
};


export type CollectionMutationSetCollectionSystemAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type CollectionMutationSetPublicArgs = {
  id: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};


export type CollectionMutationSetPublicListArgs = {
  id: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};


export type CollectionMutationSetPublicSupplementaryArgs = {
  id: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};


export type CollectionMutationSetReadyArgs = {
  id: Scalars['String']['input'];
};


export type CollectionMutationSetSupplementaryContentsArgs = {
  contentType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  supplementaryId: Scalars['String']['input'];
};


export type CollectionMutationSetSupplementaryTextContentsArgs = {
  content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  supplementaryId: Scalars['String']['input'];
};


export type CollectionMutationSetSupplementaryUploadedArgs = {
  contentType: Scalars['String']['input'];
  len: Scalars['Int']['input'];
  supplementaryId: Scalars['String']['input'];
};


export type CollectionMutationSetWorkflowStateArgs = {
  state: CollectionWorkflowState;
};


export type CollectionMutationSetWorkflowStateCompleteArgs = {
  state: CollectionWorkflowCompleteState;
};

export type CollectionSupplementary = {
  __typename?: 'CollectionSupplementary';
  attributes?: Maybe<Scalars['JSON']['output']>;
  collectionId: Scalars['String']['output'];
  content: CollectionSupplementaryContent;
  created: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  modified: Scalars['String']['output'];
  name: Scalars['String']['output'];
  planId?: Maybe<Scalars['String']['output']>;
  source: CollectionSupplementarySource;
  uploaded?: Maybe<Scalars['String']['output']>;
};

export type CollectionSupplementaryContent = {
  __typename?: 'CollectionSupplementaryContent';
  json: Scalars['JSON']['output'];
  length?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urls: CollectionSupplementaryContentUrls;
};

export type CollectionSupplementaryContentUrls = {
  __typename?: 'CollectionSupplementaryContentUrls';
  download: SignedUrl;
  upload: SignedUrl;
};

export type CollectionSupplementaryInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  collectionId: Scalars['String']['input'];
  contentLength?: InputMaybe<Scalars['Int']['input']>;
  contentType: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionSupplementarySource = {
  __typename?: 'CollectionSupplementarySource';
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
};

export type CollectionTemplate = {
  __typename?: 'CollectionTemplate';
  attributes: Array<TemplateAttribute>;
  configuration?: Maybe<Scalars['JSON']['output']>;
  defaultAttributes?: Maybe<Scalars['JSON']['output']>;
  filters?: Maybe<CollectionTemplateFilters>;
  metadata?: Maybe<Metadata>;
  ordering?: Maybe<Array<Ordering>>;
};

export type CollectionTemplateFilter = {
  __typename?: 'CollectionTemplateFilter';
  filter: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CollectionTemplateFilterInput = {
  filter: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CollectionTemplateFilters = {
  __typename?: 'CollectionTemplateFilters';
  filters: Array<CollectionTemplateFilter>;
};

export type CollectionTemplateFiltersInput = {
  filters: Array<CollectionTemplateFilterInput>;
};

export type CollectionTemplateInput = {
  attributes: Array<TemplateAttributeInput>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  defaultAttributes?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<CollectionTemplateFiltersInput>;
  ordering?: InputMaybe<Array<OrderingInput>>;
};

export type CollectionTemplates = {
  __typename?: 'CollectionTemplates';
  all: Array<CollectionTemplate>;
};

export enum CollectionType {
  Folder = 'FOLDER',
  Queue = 'QUEUE',
  Root = 'ROOT',
  Standard = 'STANDARD',
  System = 'SYSTEM'
}

export type CollectionWorkflow = {
  __typename?: 'CollectionWorkflow';
  deleteWorkflow?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
  plans: Array<WorkflowExecutionPlan>;
  running: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  stateValid?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectionWorkflowCompleteState = {
  collectionId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type CollectionWorkflowInput = {
  deleteWorkflowId?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type CollectionWorkflowState = {
  collectionId: Scalars['String']['input'];
  immediate: Scalars['Boolean']['input'];
  stateId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type ComponentContainerInput = {
  components: Array<ComponentInput>;
  style?: InputMaybe<StyleInput>;
  type: ContainerType;
};

export type ComponentInput = {
  break?: InputMaybe<BreakInput>;
  container?: InputMaybe<ComponentContainerInput>;
  end?: InputMaybe<VerseEndInput>;
  start?: InputMaybe<VerseStartInput>;
  text?: InputMaybe<TextInput>;
};

export type Configuration = {
  __typename?: 'Configuration';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  permissions: Array<ConfigurationPermission>;
  public: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ConfigurationInput = {
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
  permissions: Array<PermissionInput>;
  public: Scalars['Boolean']['input'];
  value: Scalars['JSON']['input'];
};

export type ConfigurationPermission = {
  __typename?: 'ConfigurationPermission';
  action: PermissionAction;
  group: Group;
};

export type Configurations = {
  __typename?: 'Configurations';
  all: Array<Configuration>;
  configuration?: Maybe<Configuration>;
};


export type ConfigurationsConfigurationArgs = {
  key: Scalars['String']['input'];
};

export type ConfigurationsMutation = {
  __typename?: 'ConfigurationsMutation';
  deleteConfiguration?: Maybe<Scalars['String']['output']>;
  setConfiguration?: Maybe<Configuration>;
};


export type ConfigurationsMutationDeleteConfigurationArgs = {
  key: Scalars['String']['input'];
};


export type ConfigurationsMutationSetConfigurationArgs = {
  configuration: ConfigurationInput;
};

export enum ContainerType {
  Column = 'COLUMN',
  Div = 'DIV',
  Paragraph = 'PARAGRAPH',
  Row = 'ROW',
  Span = 'SPAN',
  Table = 'TABLE'
}

export type Content = {
  __typename?: 'Content';
  categories: Categories;
  collection?: Maybe<Collection>;
  collectionSupplementary?: Maybe<CollectionSupplementary>;
  collectionTemplates: CollectionTemplates;
  documentTemplates: DocumentTemplates;
  findCollections: Array<Collection>;
  findCollectionsBySystem: Array<Collection>;
  findCollectionsCount: Scalars['Int']['output'];
  findMetadata: Array<Metadata>;
  findMetadataBySystem: Array<Metadata>;
  findMetadataCount: Scalars['Int']['output'];
  guideTemplates: GuideTemplates;
  metadata?: Maybe<Metadata>;
  metadataSupplementary?: Maybe<MetadataSupplementary>;
  slug?: Maybe<ContentItem>;
  sources: Sources;
};


export type ContentCollectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type ContentCollectionSupplementaryArgs = {
  supplementaryId: Scalars['String']['input'];
};


export type ContentFindCollectionsArgs = {
  query: FindQueryInput;
};


export type ContentFindCollectionsBySystemArgs = {
  query: FindQueryInput;
};


export type ContentFindCollectionsCountArgs = {
  query: FindQueryInput;
};


export type ContentFindMetadataArgs = {
  query: FindQueryInput;
};


export type ContentFindMetadataBySystemArgs = {
  query: FindQueryInput;
};


export type ContentFindMetadataCountArgs = {
  query: FindQueryInput;
};


export type ContentMetadataArgs = {
  id: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentMetadataSupplementaryArgs = {
  supplementaryId: Scalars['String']['input'];
};


export type ContentSlugArgs = {
  slug: Scalars['String']['input'];
};

export type ContentItem = Collection | Metadata | Profile;

export type ContentMutation = {
  __typename?: 'ContentMutation';
  category: CategoryMutation;
  collection: CollectionMutation;
  metadata: MetadataMutation;
  rebuildStorageSystemContent: Scalars['Boolean']['output'];
  resizeImage: Scalars['Boolean']['output'];
  sources: SourceMutation;
};

export enum CredentialType {
  Oauth_2 = 'OAUTH_2',
  Password = 'PASSWORD'
}

export type Document = {
  __typename?: 'Document';
  content: Scalars['JSON']['output'];
  template?: Maybe<Metadata>;
  title: Scalars['String']['output'];
};

export type DocumentInput = {
  content: Scalars['JSON']['input'];
  templateMetadataId?: InputMaybe<Scalars['String']['input']>;
  templateMetadataVersion?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  attributes: Array<TemplateAttribute>;
  configuration?: Maybe<Scalars['JSON']['output']>;
  containers: Array<DocumentTemplateContainer>;
  content: Scalars['JSON']['output'];
  defaultAttributes?: Maybe<Scalars['JSON']['output']>;
  metadata?: Maybe<Metadata>;
  schema?: Maybe<Scalars['JSON']['output']>;
};

export type DocumentTemplateContainer = {
  __typename?: 'DocumentTemplateContainer';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  supplementaryKey?: Maybe<Scalars['String']['output']>;
  type: DocumentTemplateContainerType;
  workflows: Array<TemplateWorkflow>;
};

export type DocumentTemplateContainerInput = {
  containerType?: InputMaybe<DocumentTemplateContainerType>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  supplementaryKey?: InputMaybe<Scalars['String']['input']>;
  workflows: Array<TemplateWorkflowInput>;
};

export enum DocumentTemplateContainerType {
  Bible = 'BIBLE',
  Standard = 'STANDARD'
}

export type DocumentTemplateInput = {
  attributes: Array<TemplateAttributeInput>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  containers?: InputMaybe<Array<DocumentTemplateContainerInput>>;
  content: Scalars['JSON']['input'];
  defaultAttributes?: InputMaybe<Scalars['JSON']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
};

export type DocumentTemplates = {
  __typename?: 'DocumentTemplates';
  all: Array<DocumentTemplate>;
};

export enum ExtensionFilterType {
  CollectionTemplate = 'COLLECTION_TEMPLATE',
  Document = 'DOCUMENT',
  DocumentTemplate = 'DOCUMENT_TEMPLATE',
  Guide = 'GUIDE',
  GuideTemplate = 'GUIDE_TEMPLATE'
}

export type FilteredComponent = {
  __typename?: 'FilteredComponent';
  content: Scalars['JSON']['output'];
};

export type FindAttributeInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FindAttributesInput = {
  attributes: Array<FindAttributeInput>;
};

export type FindBibleResult = {
  __typename?: 'FindBibleResult';
  book: BibleBook;
  chapter?: Maybe<BibleChapter>;
  component?: Maybe<FilteredComponent>;
  human: Scalars['String']['output'];
  usfm: Scalars['String']['output'];
};

export type FindQueryInput = {
  attributes: Array<FindAttributesInput>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  collectionType?: InputMaybe<CollectionType>;
  contentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  extensionFilter?: InputMaybe<ExtensionFilterType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<OrderingInput>>;
  traitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: GroupType;
};

export enum GroupType {
  Principal = 'PRINCIPAL',
  System = 'SYSTEM'
}

export type Groups = {
  __typename?: 'Groups';
  all: Array<Group>;
};


export type GroupsAllArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type GroupsMutation = {
  __typename?: 'GroupsMutation';
  addGroup: Group;
};


export type GroupsMutationAddGroupArgs = {
  description: Scalars['String']['input'];
  groupType: GroupType;
  name: Scalars['String']['input'];
};

export type Guide = {
  __typename?: 'Guide';
  recurrences?: Maybe<Array<Scalars['DateTime']['output']>>;
  rrule?: Maybe<Scalars['String']['output']>;
  step?: Maybe<GuideStep>;
  stepByOffset?: Maybe<GuideStep>;
  stepCount: Scalars['Int']['output'];
  steps: Array<GuideStep>;
  template?: Maybe<Metadata>;
  type: GuideType;
};


export type GuideStepArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  stepId?: InputMaybe<Scalars['Int']['input']>;
};


export type GuideStepByOffsetArgs = {
  offset: Scalars['Int']['input'];
};


export type GuideStepsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideInput = {
  guideType: GuideType;
  rrule?: InputMaybe<Scalars['String']['input']>;
  steps: Array<GuideStepInput>;
  templateMetadataId?: InputMaybe<Scalars['String']['input']>;
  templateMetadataVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideStep = {
  __typename?: 'GuideStep';
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<Metadata>;
  modules: Array<GuideStepModule>;
};

export type GuideStepInput = {
  metadata?: InputMaybe<MetadataInput>;
  modules: Array<GuideStepModuleInput>;
  stepMetadataId?: InputMaybe<Scalars['String']['input']>;
  stepMetadataVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideStepModule = {
  __typename?: 'GuideStepModule';
  id: Scalars['Int']['output'];
  metadata?: Maybe<Metadata>;
};

export type GuideStepModuleInput = {
  metadata?: InputMaybe<MetadataInput>;
  moduleMetadataId?: InputMaybe<Scalars['String']['input']>;
  moduleMetadataVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideTemplate = {
  __typename?: 'GuideTemplate';
  rrule?: Maybe<Scalars['String']['output']>;
  steps: Array<GuideTemplateStep>;
  type: GuideType;
};

export type GuideTemplateInput = {
  rrule: Scalars['String']['input'];
  steps: Array<GuideTemplateStepInput>;
  type: GuideType;
};

export type GuideTemplateStep = {
  __typename?: 'GuideTemplateStep';
  id: Scalars['Int']['output'];
  metadata?: Maybe<Metadata>;
  modules: Array<GuideTemplateStepModule>;
};

export type GuideTemplateStepInput = {
  modules: Array<GuideTemplateStepModuleInput>;
  templateMetadataId: Scalars['String']['input'];
  templateMetadataVersion: Scalars['Int']['input'];
};

export type GuideTemplateStepModule = {
  __typename?: 'GuideTemplateStepModule';
  id: Scalars['Int']['output'];
  metadata?: Maybe<Metadata>;
};

export type GuideTemplateStepModuleInput = {
  templateMetadataId: Scalars['String']['input'];
  templateMetadataVersion: Scalars['Int']['input'];
};

export type GuideTemplates = {
  __typename?: 'GuideTemplates';
  all: Array<GuideTemplate>;
};

export enum GuideType {
  Calendar = 'CALENDAR',
  CalendarProgress = 'CALENDAR_PROGRESS',
  Linear = 'LINEAR',
  LinearProgress = 'LINEAR_PROGRESS'
}

export type Login = {
  __typename?: 'Login';
  password: LoginResponse;
};


export type LoginPasswordArgs = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginMutation = {
  __typename?: 'LoginMutation';
  forgotPassword: Scalars['Boolean']['output'];
  password: LoginResponse;
  refreshToken: LoginResponse;
};


export type LoginMutationForgotPasswordArgs = {
  identifier: Scalars['String']['input'];
};


export type LoginMutationPasswordArgs = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type LoginMutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  principal: Principal;
  profile?: Maybe<Profile>;
  refreshToken: Scalars['String']['output'];
  token: Token;
};

export type Metadata = {
  __typename?: 'Metadata';
  attributes?: Maybe<Scalars['JSON']['output']>;
  bible?: Maybe<Bible>;
  categories: Array<Category>;
  collectionTemplate?: Maybe<CollectionTemplate>;
  content: MetadataContent;
  created: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  document?: Maybe<Document>;
  documentTemplate?: Maybe<DocumentTemplate>;
  etag?: Maybe<Scalars['String']['output']>;
  guide?: Maybe<Guide>;
  guideTemplate?: Maybe<GuideTemplate>;
  id: Scalars['String']['output'];
  itemAttributes?: Maybe<Scalars['JSON']['output']>;
  labels: Array<Scalars['String']['output']>;
  languageTag: Scalars['String']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  parentCollections: Array<Collection>;
  parentId?: Maybe<Scalars['String']['output']>;
  permissions: Array<Permission>;
  profiles: Array<MetadataProfile>;
  public: Scalars['Boolean']['output'];
  publicContent: Scalars['Boolean']['output'];
  publicSupplementary: Scalars['Boolean']['output'];
  ready?: Maybe<Scalars['DateTime']['output']>;
  relationships: Array<MetadataRelationship>;
  slug?: Maybe<Scalars['String']['output']>;
  source: MetadataSource;
  supplementary: Array<MetadataSupplementary>;
  systemAttributes?: Maybe<Scalars['JSON']['output']>;
  traitIds: Array<Scalars['String']['output']>;
  type: MetadataType;
  uploaded?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
  workflow: MetadataWorkflow;
};


export type MetadataAttributesArgs = {
  filter?: InputMaybe<AttributesFilterInput>;
};


export type MetadataBibleArgs = {
  variant?: InputMaybe<Scalars['String']['input']>;
};


export type MetadataEtagArgs = {
  addHeader: Scalars['Boolean']['input'];
};


export type MetadataParentCollectionsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type MetadataRelationshipsArgs = {
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  inverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetadataSupplementaryArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataChildInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  metadata: MetadataInput;
};

export type MetadataContent = {
  __typename?: 'MetadataContent';
  json: Scalars['JSON']['output'];
  length?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urls: MetadataContentUrls;
};

export type MetadataContentUrls = {
  __typename?: 'MetadataContentUrls';
  download: SignedUrl;
  upload: SignedUrl;
};

export type MetadataInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  collectionTemplate?: InputMaybe<CollectionTemplateInput>;
  contentLength?: InputMaybe<Scalars['Int']['input']>;
  contentType: Scalars['String']['input'];
  document?: InputMaybe<DocumentInput>;
  documentTemplate?: InputMaybe<DocumentTemplateInput>;
  guide?: InputMaybe<GuideInput>;
  guideTemplate?: InputMaybe<GuideTemplateInput>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  languageTag: Scalars['String']['input'];
  metadataType?: InputMaybe<MetadataType>;
  name: Scalars['String']['input'];
  parentCollectionId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<Array<MetadataProfileInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetadataSourceInput>;
  state?: InputMaybe<MetadataWorkflowInput>;
  traitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type MetadataMutation = {
  __typename?: 'MetadataMutation';
  add: Metadata;
  addBulk: Array<Metadata>;
  addCategory: Scalars['Boolean']['output'];
  addDocument?: Maybe<Metadata>;
  addGuide?: Maybe<Metadata>;
  addGuideStep: GuideStep;
  addGuideStepModule: GuideStepModule;
  addPermission: Permission;
  addRelationship: MetadataRelationship;
  addSupplementary: MetadataSupplementary;
  addTrait: Array<WorkflowExecutionPlan>;
  delete: Scalars['Boolean']['output'];
  deleteCategory: Scalars['Boolean']['output'];
  deleteContent: Scalars['Boolean']['output'];
  deleteGuide: Scalars['Boolean']['output'];
  deleteGuideStep: Scalars['Boolean']['output'];
  deletePermission: Permission;
  deleteRelationship: Scalars['Boolean']['output'];
  deleteSupplementary: Scalars['Boolean']['output'];
  deleteTrait: Array<WorkflowExecutionPlan>;
  detachSupplementary: Scalars['Boolean']['output'];
  edit: Metadata;
  editRelationship: Scalars['Boolean']['output'];
  mergeMetadataAttributes: Scalars['Boolean']['output'];
  mergeMetadataRelationshipAttributes: Scalars['Boolean']['output'];
  permanentlyDelete: Scalars['Boolean']['output'];
  setGuideStartDate?: Maybe<Metadata>;
  setMetadataAttributes: Scalars['Boolean']['output'];
  setMetadataBible: Scalars['Boolean']['output'];
  setMetadataContents: Scalars['Boolean']['output'];
  setMetadataDocument: Scalars['Boolean']['output'];
  setMetadataJsonContents: Scalars['Boolean']['output'];
  setMetadataReady: Scalars['Boolean']['output'];
  setMetadataSystemAttributes: Scalars['Boolean']['output'];
  setMetadataTextContents: Scalars['Boolean']['output'];
  setMetadataUploaded: Scalars['Boolean']['output'];
  setPublic: Metadata;
  setPublicContent: Metadata;
  setPublicSupplementary: Metadata;
  setSupplementaryContents: Scalars['Boolean']['output'];
  setSupplementaryTextContents: Scalars['Boolean']['output'];
  setSupplementaryUploaded: Scalars['Boolean']['output'];
  setWorkflowState: Scalars['Boolean']['output'];
  setWorkflowStateComplete: Scalars['Boolean']['output'];
};


export type MetadataMutationAddArgs = {
  collectionItemAttributes?: InputMaybe<Scalars['JSON']['input']>;
  metadata: MetadataInput;
};


export type MetadataMutationAddBulkArgs = {
  metadatas: Array<MetadataChildInput>;
};


export type MetadataMutationAddCategoryArgs = {
  categoryId: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
};


export type MetadataMutationAddDocumentArgs = {
  parentCollectionId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  templateVersion: Scalars['Int']['input'];
};


export type MetadataMutationAddGuideArgs = {
  parentCollectionId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  templateVersion: Scalars['Int']['input'];
};


export type MetadataMutationAddGuideStepArgs = {
  metadataId: Scalars['String']['input'];
  metadataVersion: Scalars['Int']['input'];
  sort: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
  templateStepId: Scalars['Int']['input'];
  templateVersion: Scalars['Int']['input'];
};


export type MetadataMutationAddGuideStepModuleArgs = {
  metadataId: Scalars['String']['input'];
  metadataVersion: Scalars['Int']['input'];
  sort: Scalars['Int']['input'];
  stepId: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
  templateModuleId: Scalars['Int']['input'];
  templateStepId: Scalars['Int']['input'];
  templateVersion: Scalars['Int']['input'];
};


export type MetadataMutationAddPermissionArgs = {
  permission: PermissionInput;
};


export type MetadataMutationAddRelationshipArgs = {
  relationship: MetadataRelationshipInput;
};


export type MetadataMutationAddSupplementaryArgs = {
  supplementary: MetadataSupplementaryInput;
};


export type MetadataMutationAddTraitArgs = {
  metadataId: Scalars['String']['input'];
  traitId: Scalars['String']['input'];
};


export type MetadataMutationDeleteArgs = {
  metadataId: Scalars['String']['input'];
};


export type MetadataMutationDeleteCategoryArgs = {
  categoryId: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
};


export type MetadataMutationDeleteContentArgs = {
  metadataId: Scalars['String']['input'];
};


export type MetadataMutationDeleteGuideArgs = {
  metadataId: Scalars['String']['input'];
  metadataVersion: Scalars['Int']['input'];
};


export type MetadataMutationDeleteGuideStepArgs = {
  metadataId: Scalars['String']['input'];
  metadataVersion: Scalars['Int']['input'];
  stepId: Scalars['Int']['input'];
};


export type MetadataMutationDeletePermissionArgs = {
  permission: PermissionInput;
};


export type MetadataMutationDeleteRelationshipArgs = {
  id1: Scalars['String']['input'];
  id2: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};


export type MetadataMutationDeleteSupplementaryArgs = {
  id: Scalars['String']['input'];
};


export type MetadataMutationDeleteTraitArgs = {
  metadataId: Scalars['String']['input'];
  traitId: Scalars['String']['input'];
};


export type MetadataMutationDetachSupplementaryArgs = {
  id: Scalars['String']['input'];
};


export type MetadataMutationEditArgs = {
  id: Scalars['String']['input'];
  metadata: MetadataInput;
};


export type MetadataMutationEditRelationshipArgs = {
  relationship: MetadataRelationshipInput;
};


export type MetadataMutationMergeMetadataAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type MetadataMutationMergeMetadataRelationshipAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  metadata1Id: Scalars['String']['input'];
  metadata2Id: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};


export type MetadataMutationPermanentlyDeleteArgs = {
  metadataId: Scalars['String']['input'];
};


export type MetadataMutationSetGuideStartDateArgs = {
  date: Scalars['DateTime']['input'];
  metadataId: Scalars['String']['input'];
  metadataVersion: Scalars['Int']['input'];
};


export type MetadataMutationSetMetadataAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type MetadataMutationSetMetadataBibleArgs = {
  bible: BibleInput;
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MetadataMutationSetMetadataContentsArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  id: Scalars['String']['input'];
};


export type MetadataMutationSetMetadataDocumentArgs = {
  document: DocumentInput;
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MetadataMutationSetMetadataJsonContentsArgs = {
  content: Scalars['JSON']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MetadataMutationSetMetadataReadyArgs = {
  configurations?: InputMaybe<Array<WorkflowConfigurationInput>>;
  id: Scalars['String']['input'];
};


export type MetadataMutationSetMetadataSystemAttributesArgs = {
  attributes: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type MetadataMutationSetMetadataTextContentsArgs = {
  content: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MetadataMutationSetMetadataUploadedArgs = {
  configurations?: InputMaybe<Array<WorkflowConfigurationInput>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  len: Scalars['Int']['input'];
  ready?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetadataMutationSetPublicArgs = {
  id: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};


export type MetadataMutationSetPublicContentArgs = {
  id: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};


export type MetadataMutationSetPublicSupplementaryArgs = {
  id: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};


export type MetadataMutationSetSupplementaryContentsArgs = {
  contentType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  supplementaryId: Scalars['String']['input'];
};


export type MetadataMutationSetSupplementaryTextContentsArgs = {
  content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  supplementaryId: Scalars['String']['input'];
};


export type MetadataMutationSetSupplementaryUploadedArgs = {
  contentType: Scalars['String']['input'];
  len: Scalars['Int']['input'];
  supplementaryId: Scalars['String']['input'];
};


export type MetadataMutationSetWorkflowStateArgs = {
  state: MetadataWorkflowState;
};


export type MetadataMutationSetWorkflowStateCompleteArgs = {
  state: MetadataWorkflowCompleteState;
};

export type MetadataProfile = {
  __typename?: 'MetadataProfile';
  profile?: Maybe<Profile>;
  relationship: Scalars['String']['output'];
};

export type MetadataProfileInput = {
  profileId: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};

export type MetadataRelationship = {
  __typename?: 'MetadataRelationship';
  attributes?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  metadata: Metadata;
  relationship: Scalars['String']['output'];
};

export type MetadataRelationshipInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  id1: Scalars['String']['input'];
  id2: Scalars['String']['input'];
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSource = {
  __typename?: 'MetadataSource';
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type MetadataSourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSupplementary = {
  __typename?: 'MetadataSupplementary';
  attributes?: Maybe<Scalars['JSON']['output']>;
  content: MetadataSupplementaryContent;
  created: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  metadataId: Scalars['String']['output'];
  modified: Scalars['String']['output'];
  name: Scalars['String']['output'];
  planId?: Maybe<Scalars['String']['output']>;
  source: MetadataSupplementarySource;
  uploaded?: Maybe<Scalars['String']['output']>;
};

export type MetadataSupplementaryContent = {
  __typename?: 'MetadataSupplementaryContent';
  json: Scalars['JSON']['output'];
  length?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urls: MetadataSupplementaryContentUrls;
};

export type MetadataSupplementaryContentUrls = {
  __typename?: 'MetadataSupplementaryContentUrls';
  download: SignedUrl;
  upload: SignedUrl;
};

export type MetadataSupplementaryInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  contentLength?: InputMaybe<Scalars['Int']['input']>;
  contentType: Scalars['String']['input'];
  key: Scalars['String']['input'];
  metadataId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSupplementarySource = {
  __typename?: 'MetadataSupplementarySource';
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
};

export enum MetadataType {
  Standard = 'STANDARD',
  Variant = 'VARIANT'
}

export type MetadataWorkflow = {
  __typename?: 'MetadataWorkflow';
  deleteWorkflow?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
  plans: Array<WorkflowExecutionPlan>;
  running: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  stateValid?: Maybe<Scalars['DateTime']['output']>;
};

export type MetadataWorkflowCompleteState = {
  metadataId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type MetadataWorkflowInput = {
  deleteWorkflowId?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type MetadataWorkflowState = {
  immediate: Scalars['Boolean']['input'];
  metadataId: Scalars['String']['input'];
  stateId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type Model = {
  __typename?: 'Model';
  configuration: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ModelInput = {
  configuration: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type Models = {
  __typename?: 'Models';
  all: Array<Model>;
  model?: Maybe<Model>;
};


export type ModelsModelArgs = {
  id: Scalars['String']['input'];
};

export type ModelsMutation = {
  __typename?: 'ModelsMutation';
  add?: Maybe<Model>;
  delete: Scalars['Boolean']['output'];
  edit?: Maybe<Model>;
};


export type ModelsMutationAddArgs = {
  model: ModelInput;
};


export type ModelsMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type ModelsMutationEditArgs = {
  id: Scalars['String']['input'];
  model: ModelInput;
};

export type Mutation = {
  __typename?: 'Mutation';
  clearCache: Scalars['Boolean']['output'];
  configurations: ConfigurationsMutation;
  content: ContentMutation;
  persistedQueries: PersistedQueriesMutation;
  profiles: ProfilesMutation;
  security: SecurityMutation;
  workflows: WorkflowsMutation;
};

export enum Order {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type Ordering = {
  __typename?: 'Ordering';
  field?: Maybe<Scalars['String']['output']>;
  location?: Maybe<AttributeLocation>;
  order: Order;
  path?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<AttributeType>;
};

export type OrderingInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AttributeLocation>;
  order: Order;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<AttributeType>;
};

export type Permission = {
  __typename?: 'Permission';
  action: PermissionAction;
  group: Group;
  groupId: Scalars['String']['output'];
};

export enum PermissionAction {
  Delete = 'DELETE',
  Edit = 'EDIT',
  Execute = 'EXECUTE',
  Impersonate = 'IMPERSONATE',
  List = 'LIST',
  Manage = 'MANAGE',
  View = 'VIEW'
}

export type PermissionInput = {
  action: PermissionAction;
  entityId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};

export type PersistedQueriesMutation = {
  __typename?: 'PersistedQueriesMutation';
  add: Scalars['Boolean']['output'];
  addAll: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  deleteAll: Scalars['Boolean']['output'];
};


export type PersistedQueriesMutationAddArgs = {
  application: Scalars['String']['input'];
  query: Scalars['String']['input'];
  sha256: Scalars['String']['input'];
};


export type PersistedQueriesMutationAddAllArgs = {
  application: Scalars['String']['input'];
  queries: Array<PersistedQueryInput>;
};


export type PersistedQueriesMutationDeleteArgs = {
  application: Scalars['String']['input'];
  sha256: Scalars['String']['input'];
};

export type PersistedQueriesObject = {
  __typename?: 'PersistedQueriesObject';
  all: Array<PersistedQuery>;
  query?: Maybe<PersistedQuery>;
};


export type PersistedQueriesObjectQueryArgs = {
  sha256: Scalars['String']['input'];
};

export type PersistedQuery = {
  __typename?: 'PersistedQuery';
  application: Scalars['String']['output'];
  query: Scalars['String']['output'];
  sha256: Scalars['String']['output'];
};

export type PersistedQueryInput = {
  query: Scalars['String']['input'];
  sha256: Scalars['String']['input'];
};

export type Principal = {
  __typename?: 'Principal';
  credentials: Array<PrincipalCredential>;
  groups: Array<Group>;
  id: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type PrincipalCredential = {
  __typename?: 'PrincipalCredential';
  identifier: Scalars['String']['output'];
  type: CredentialType;
};

export type PrincipalMutation = {
  __typename?: 'PrincipalMutation';
  identifier: Scalars['Boolean']['output'];
  password: Scalars['Boolean']['output'];
};


export type PrincipalMutationIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


export type PrincipalMutationPasswordArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type Principals = {
  __typename?: 'Principals';
  all: Array<Principal>;
  current: Principal;
};


export type PrincipalsAllArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type Profile = {
  __typename?: 'Profile';
  attributes: Array<ProfileAttribute>;
  bookmarks: ProfileBookmarks;
  collection?: Maybe<Collection>;
  guides: ProfileGuides;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  principal?: Maybe<Principal>;
  slug?: Maybe<Scalars['String']['output']>;
  visibility: ProfileVisibility;
};

export type ProfileAttribute = {
  __typename?: 'ProfileAttribute';
  attributes?: Maybe<Scalars['JSON']['output']>;
  confidence: Scalars['Int']['output'];
  expires?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  priority: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  typeId: Scalars['String']['output'];
  visibility: ProfileVisibility;
};

export type ProfileAttributeInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  confidence: Scalars['Int']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  metadataSupplementary?: InputMaybe<Scalars['String']['input']>;
  priority: Scalars['Int']['input'];
  source: Scalars['String']['input'];
  typeId: Scalars['String']['input'];
  visibility: ProfileVisibility;
};

export type ProfileAttributeType = {
  __typename?: 'ProfileAttributeType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  visibility: ProfileVisibility;
};

export type ProfileAttributeTypeInput = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  visibility: ProfileVisibility;
};

export type ProfileAttributeTypes = {
  __typename?: 'ProfileAttributeTypes';
  all: Array<ProfileAttributeType>;
};

export type ProfileBookmark = {
  __typename?: 'ProfileBookmark';
  collection?: Maybe<Collection>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Metadata>;
};

export type ProfileBookmarks = {
  __typename?: 'ProfileBookmarks';
  bookmark?: Maybe<ProfileBookmark>;
  bookmarks: Array<ProfileBookmark>;
  count: Scalars['Int']['output'];
};


export type ProfileBookmarksBookmarkArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  metadataVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileGuideHistories = {
  __typename?: 'ProfileGuideHistories';
  all: Array<ProfileGuideHistory>;
  count: Scalars['Int']['output'];
  history: Array<ProfileGuideHistory>;
  historyCount: Scalars['Int']['output'];
};


export type ProfileGuideHistoriesAllArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type ProfileGuideHistoriesHistoryArgs = {
  id: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  version: Scalars['Int']['input'];
};


export type ProfileGuideHistoriesHistoryCountArgs = {
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type ProfileGuideHistory = {
  __typename?: 'ProfileGuideHistory';
  attributes: Scalars['JSON']['output'];
  completed?: Maybe<Scalars['DateTime']['output']>;
  metadata: Metadata;
};

export type ProfileGuideProgress = {
  __typename?: 'ProfileGuideProgress';
  attributes: Scalars['JSON']['output'];
  completedStepIds: Array<Scalars['Int']['output']>;
  metadata: Metadata;
  modified: Scalars['DateTime']['output'];
  nextStepId?: Maybe<Scalars['Int']['output']>;
  percentage: Scalars['Float']['output'];
  started: Scalars['DateTime']['output'];
};

export type ProfileGuideProgressions = {
  __typename?: 'ProfileGuideProgressions';
  all: Array<ProfileGuideProgress>;
  count: Scalars['Int']['output'];
  progress?: Maybe<ProfileGuideProgress>;
};


export type ProfileGuideProgressionsAllArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type ProfileGuideProgressionsProgressArgs = {
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type ProfileGuides = {
  __typename?: 'ProfileGuides';
  history: ProfileGuideHistories;
  progressions: ProfileGuideProgressions;
};

export type ProfileInput = {
  attributes: Array<ProfileAttributeInput>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  visibility: ProfileVisibility;
};

export type ProfileMutation = {
  __typename?: 'ProfileMutation';
  addBookmark: Scalars['Boolean']['output'];
  addProgress?: Maybe<ProfileGuideProgress>;
  deleteAttribute: Scalars['Boolean']['output'];
  deleteBookmark: Scalars['Boolean']['output'];
};


export type ProfileMutationAddBookmarkArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileMutationAddProgressArgs = {
  attributes: Scalars['JSON']['input'];
  metadataId: Scalars['String']['input'];
  metadataVersion: Scalars['Int']['input'];
  stepId: Scalars['Int']['input'];
};


export type ProfileMutationDeleteAttributeArgs = {
  attributeId: Scalars['String']['input'];
};


export type ProfileMutationDeleteBookmarkArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProfileVisibility {
  Friends = 'FRIENDS',
  FriendsOfFriends = 'FRIENDS_OF_FRIENDS',
  Public = 'PUBLIC',
  System = 'SYSTEM',
  User = 'USER'
}

export type Profiles = {
  __typename?: 'Profiles';
  all: Array<Profile>;
  attributeTypes: ProfileAttributeTypes;
  current?: Maybe<Profile>;
  profile?: Maybe<Profile>;
};


export type ProfilesAllArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type ProfilesProfileArgs = {
  id: Scalars['String']['input'];
};

export type ProfilesMutation = {
  __typename?: 'ProfilesMutation';
  add?: Maybe<Profile>;
  addAttributeType: Scalars['Boolean']['output'];
  deleteAttribute: Scalars['Boolean']['output'];
  deleteAttributeType: Scalars['Boolean']['output'];
  edit?: Maybe<Profile>;
  editAttributeType: Scalars['Boolean']['output'];
  profile: ProfileMutation;
};


export type ProfilesMutationAddArgs = {
  profile: ProfileInput;
};


export type ProfilesMutationAddAttributeTypeArgs = {
  attribute: ProfileAttributeTypeInput;
};


export type ProfilesMutationDeleteAttributeArgs = {
  attributeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};


export type ProfilesMutationDeleteAttributeTypeArgs = {
  attributeId: Scalars['String']['input'];
};


export type ProfilesMutationEditArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  profile: ProfileInput;
};


export type ProfilesMutationEditAttributeTypeArgs = {
  attribute: ProfileAttributeTypeInput;
};

export type Prompt = {
  __typename?: 'Prompt';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inputType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputType: Scalars['String']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  systemPrompt: Scalars['String']['output'];
  userPrompt: Scalars['String']['output'];
};

export type PromptInput = {
  description: Scalars['String']['input'];
  inputType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  outputType: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['JSON']['input']>;
  systemPrompt: Scalars['String']['input'];
  userPrompt: Scalars['String']['input'];
};

export type Prompts = {
  __typename?: 'Prompts';
  all: Array<Prompt>;
  prompt?: Maybe<Prompt>;
};


export type PromptsPromptArgs = {
  id: Scalars['String']['input'];
};

export type PromptsMutation = {
  __typename?: 'PromptsMutation';
  add?: Maybe<Prompt>;
  delete: Scalars['Boolean']['output'];
  edit?: Maybe<Prompt>;
};


export type PromptsMutationAddArgs = {
  prompt: PromptInput;
};


export type PromptsMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PromptsMutationEditArgs = {
  id: Scalars['String']['input'];
  prompt: PromptInput;
};

export type Query = {
  __typename?: 'Query';
  caches: CachesObject;
  configurations: Configurations;
  content: Content;
  persistedQueries: PersistedQueriesObject;
  profiles: Profiles;
  search: SearchResultObject;
  security: Security;
  server: Server;
  workflows: Workflows;
};


export type QuerySearchArgs = {
  query: SearchQuery;
};

export type ReferenceInput = {
  usfm: Scalars['String']['input'];
};

export type SearchDocument = {
  __typename?: 'SearchDocument';
  collection?: Maybe<Collection>;
  metadata?: Maybe<Metadata>;
  profile?: Maybe<Profile>;
};

export type SearchQuery = {
  facets?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  sort?: InputMaybe<Array<Scalars['String']['input']>>;
  storageSystemId?: InputMaybe<Scalars['String']['input']>;
  storageSystemName?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResultFacet = {
  __typename?: 'SearchResultFacet';
  count: Scalars['Int']['output'];
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SearchResultObject = {
  __typename?: 'SearchResultObject';
  documents: Array<SearchDocument>;
  estimatedHits: Scalars['Int']['output'];
  facets: Array<SearchResultFacet>;
};

export type Security = {
  __typename?: 'Security';
  actions: Array<Scalars['String']['output']>;
  groups: Groups;
  login: Login;
  principal: Principal;
  principals: Principals;
};

export type SecurityMutation = {
  __typename?: 'SecurityMutation';
  addPrincipalGroup: Scalars['Boolean']['output'];
  expireRefreshTokens: Scalars['Boolean']['output'];
  groups: GroupsMutation;
  login: LoginMutation;
  password: Scalars['Boolean']['output'];
  principal: PrincipalMutation;
  removePrincipalGroup: Scalars['Boolean']['output'];
  signup: SignupMutation;
};


export type SecurityMutationAddPrincipalGroupArgs = {
  groupId: Scalars['String']['input'];
  principalId: Scalars['String']['input'];
};


export type SecurityMutationPasswordArgs = {
  newPassword: Scalars['String']['input'];
  verificationToken: Scalars['String']['input'];
};


export type SecurityMutationPrincipalArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type SecurityMutationRemovePrincipalGroupArgs = {
  groupId: Scalars['String']['input'];
  principalId: Scalars['String']['input'];
};

export type Server = {
  __typename?: 'Server';
  now: Scalars['DateTime']['output'];
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  headers: Array<SignedUrlHeader>;
  url: Scalars['String']['output'];
};

export type SignedUrlHeader = {
  __typename?: 'SignedUrlHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SignupMutation = {
  __typename?: 'SignupMutation';
  password: Principal;
  passwordVerify: Scalars['Boolean']['output'];
  resendPasswordVerification: Scalars['Boolean']['output'];
};


export type SignupMutationPasswordArgs = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profile: ProfileInput;
};


export type SignupMutationPasswordVerifyArgs = {
  verificationToken: Scalars['String']['input'];
};


export type SignupMutationResendPasswordVerificationArgs = {
  identifier: Scalars['String']['input'];
};

export type Source = {
  __typename?: 'Source';
  configuration: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SourceInput = {
  configuration: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SourceMutation = {
  __typename?: 'SourceMutation';
  add?: Maybe<Source>;
};


export type SourceMutationAddArgs = {
  source: SourceInput;
};

export type Sources = {
  __typename?: 'Sources';
  all: Array<Source>;
  source?: Maybe<Source>;
};


export type SourcesSourceArgs = {
  id: Scalars['String']['input'];
};

export type StorageSystem = {
  __typename?: 'StorageSystem';
  configuration?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  models: Array<StorageSystemModel>;
  name: Scalars['String']['output'];
  type: StorageSystemType;
};

export type StorageSystemInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  models: Array<StorageSystemModelInput>;
  name: Scalars['String']['input'];
  type: StorageSystemType;
};

export type StorageSystemModel = {
  __typename?: 'StorageSystemModel';
  configuration: Scalars['JSON']['output'];
  model?: Maybe<Model>;
  modelId: Scalars['String']['output'];
};

export type StorageSystemModelInput = {
  configuration: Scalars['JSON']['input'];
  modelId: Scalars['String']['input'];
};

export enum StorageSystemType {
  Search = 'SEARCH',
  Supplementary = 'SUPPLEMENTARY',
  Vector = 'VECTOR'
}

export type StorageSystems = {
  __typename?: 'StorageSystems';
  all: Array<StorageSystem>;
  storageSystem?: Maybe<StorageSystem>;
};


export type StorageSystemsStorageSystemArgs = {
  id: Scalars['String']['input'];
};

export type StorageSystemsMutation = {
  __typename?: 'StorageSystemsMutation';
  add?: Maybe<StorageSystem>;
  delete: Scalars['Boolean']['output'];
  edit?: Maybe<StorageSystem>;
};


export type StorageSystemsMutationAddArgs = {
  storageSystem: StorageSystemInput;
};


export type StorageSystemsMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type StorageSystemsMutationEditArgs = {
  id: Scalars['String']['input'];
  storageSystem: StorageSystemInput;
};

export type StyleInput = {
  align?: InputMaybe<Scalars['String']['input']>;
  fontWeight?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  reference: Scalars['Boolean']['input'];
  textIndent?: InputMaybe<TextIndentInput>;
};

export type Subscription = {
  __typename?: 'Subscription';
  activity: Scalars['String']['output'];
  category: Scalars['String']['output'];
  collection: Scalars['String']['output'];
  collectionSupplementary: SupplementaryIdObject;
  configuration: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  metadataSupplementary: SupplementaryIdObject;
  model: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  state: Scalars['String']['output'];
  storageSystem: Scalars['String']['output'];
  trait: Scalars['String']['output'];
  transition: TransitionIdObject;
  workflow: Scalars['String']['output'];
  workflowPlanFailed: WorkflowExecutionId;
  workflowPlanFinished: WorkflowExecutionId;
  workflowSchedule: Scalars['String']['output'];
};

export type SupplementaryIdObject = {
  __typename?: 'SupplementaryIdObject';
  contentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  planId?: Maybe<Scalars['String']['output']>;
};

export type TemplateAttribute = {
  __typename?: 'TemplateAttribute';
  configuration?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  list: Scalars['Boolean']['output'];
  location: AttributeLocation;
  name: Scalars['String']['output'];
  supplementaryKey?: Maybe<Scalars['String']['output']>;
  type: AttributeType;
  ui: AttributeUiType;
  workflows: Array<TemplateWorkflow>;
};

export type TemplateAttributeInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
  list: Scalars['Boolean']['input'];
  location?: InputMaybe<AttributeLocation>;
  name: Scalars['String']['input'];
  supplementaryKey?: InputMaybe<Scalars['String']['input']>;
  type: AttributeType;
  ui: AttributeUiType;
  workflows: Array<TemplateWorkflowInput>;
};

export type TemplateWorkflow = {
  __typename?: 'TemplateWorkflow';
  autoRun: Scalars['Boolean']['output'];
  workflow?: Maybe<Workflow>;
};

export type TemplateWorkflowInput = {
  autoRun: Scalars['Boolean']['input'];
  workflowId: Scalars['String']['input'];
};

export type TextIndentInput = {
  size: Scalars['Float']['input'];
  unit: Scalars['String']['input'];
};

export type TextInput = {
  style?: InputMaybe<StyleInput>;
  text: Scalars['String']['input'];
};

export type Token = {
  __typename?: 'Token';
  expiresAt: Scalars['Int']['output'];
  issuedAt: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type Trait = {
  __typename?: 'Trait';
  contentTypes: Array<Scalars['String']['output']>;
  deleteWorkflowId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  workflowIds: Array<Scalars['String']['output']>;
  workflows: Array<Workflow>;
};

export type TraitInput = {
  contentTypes: Array<Scalars['String']['input']>;
  deleteWorkflowId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workflowIds: Array<Scalars['String']['input']>;
};

export type Traits = {
  __typename?: 'Traits';
  all: Array<Trait>;
  trait?: Maybe<Trait>;
};


export type TraitsTraitArgs = {
  id: Scalars['String']['input'];
};

export type TraitsMutation = {
  __typename?: 'TraitsMutation';
  add?: Maybe<Trait>;
  delete: Scalars['Boolean']['output'];
  edit?: Maybe<Trait>;
};


export type TraitsMutationAddArgs = {
  model: TraitInput;
};


export type TraitsMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type TraitsMutationEditArgs = {
  model: TraitInput;
};

export type Transition = {
  __typename?: 'Transition';
  description: Scalars['String']['output'];
  fromStateId: Scalars['String']['output'];
  toStateId: Scalars['String']['output'];
};

export type TransitionIdObject = {
  __typename?: 'TransitionIdObject';
  fromStateId: Scalars['String']['output'];
  toStateId: Scalars['String']['output'];
};

export type TransitionInput = {
  description: Scalars['String']['input'];
  fromStateId: Scalars['String']['input'];
  toStateId: Scalars['String']['input'];
};

export type Transitions = {
  __typename?: 'Transitions';
  all: Array<Transition>;
  transition?: Maybe<Transition>;
};


export type TransitionsTransitionArgs = {
  fromStateId: Scalars['String']['input'];
  toStateId: Scalars['String']['input'];
};

export type TransitionsMutation = {
  __typename?: 'TransitionsMutation';
  add?: Maybe<Transition>;
  delete: Scalars['Boolean']['output'];
  edit?: Maybe<Transition>;
};


export type TransitionsMutationAddArgs = {
  transition: TransitionInput;
};


export type TransitionsMutationDeleteArgs = {
  fromStateId: Scalars['String']['input'];
  toStateId: Scalars['String']['input'];
};


export type TransitionsMutationEditArgs = {
  transition: TransitionInput;
};

export type VerseEndInput = {
  reference: ReferenceInput;
};

export type VerseStartInput = {
  reference: ReferenceInput;
};

export type Workflow = {
  __typename?: 'Workflow';
  activities: Array<WorkflowActivity>;
  configuration: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  queue: Scalars['String']['output'];
};

export type WorkflowActivity = {
  __typename?: 'WorkflowActivity';
  activityId: Scalars['String']['output'];
  configuration?: Maybe<Scalars['JSON']['output']>;
  executionGroup: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inputs: Array<WorkflowActivityParameter>;
  models: Array<WorkflowActivityModel>;
  outputs: Array<WorkflowActivityParameter>;
  prompts: Array<WorkflowActivityPrompt>;
  queue: Scalars['String']['output'];
  storageSystems: Array<WorkflowActivityStorageSystem>;
};

export type WorkflowActivityInput = {
  activityId: Scalars['String']['input'];
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  executionGroup: Scalars['Int']['input'];
  inputs: Array<WorkflowActivityParameterInput>;
  models: Array<WorkflowActivityModelInput>;
  outputs: Array<WorkflowActivityParameterInput>;
  prompts: Array<WorkflowActivityPromptInput>;
  queue: Scalars['String']['input'];
  storageSystems: Array<WorkflowActivityStorageSystemInput>;
};

export type WorkflowActivityModel = {
  __typename?: 'WorkflowActivityModel';
  configuration?: Maybe<Scalars['JSON']['output']>;
  model: Model;
};

export type WorkflowActivityModelInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  modelId: Scalars['String']['input'];
};

export type WorkflowActivityParameter = {
  __typename?: 'WorkflowActivityParameter';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WorkflowActivityParameterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type WorkflowActivityPrompt = {
  __typename?: 'WorkflowActivityPrompt';
  configuration?: Maybe<Scalars['JSON']['output']>;
  prompt: Prompt;
};

export type WorkflowActivityPromptInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  promptId: Scalars['String']['input'];
};

export type WorkflowActivityStorageSystem = {
  __typename?: 'WorkflowActivityStorageSystem';
  configuration?: Maybe<Scalars['JSON']['output']>;
  system: StorageSystem;
};

export type WorkflowActivityStorageSystemInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  systemId: Scalars['String']['input'];
};

export type WorkflowConfigurationInput = {
  activityId: Scalars['String']['input'];
  configuration: Scalars['JSON']['input'];
};

export type WorkflowExecution = WorkflowExecutionPlan | WorkflowJob;

export type WorkflowExecutionId = {
  __typename?: 'WorkflowExecutionId';
  id: Scalars['String']['output'];
  queue: Scalars['String']['output'];
};

export type WorkflowExecutionIdInput = {
  id: Scalars['String']['input'];
  queue: Scalars['String']['input'];
};

export type WorkflowExecutionPlan = {
  __typename?: 'WorkflowExecutionPlan';
  active: Array<Scalars['Int']['output']>;
  cancelled: Scalars['Boolean']['output'];
  collectionId?: Maybe<Scalars['String']['output']>;
  complete: Array<Scalars['Int']['output']>;
  context?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  failed: Array<Scalars['Int']['output']>;
  id: WorkflowExecutionId;
  jobs: Array<WorkflowJob>;
  metadata?: Maybe<Metadata>;
  metadataId?: Maybe<Scalars['String']['output']>;
  metadataVersion?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<WorkflowJobId>;
  supplementaryId?: Maybe<Scalars['String']['output']>;
  workflow: Workflow;
};

export type WorkflowInput = {
  activities: Array<WorkflowActivityInput>;
  configuration: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  queue: Scalars['String']['input'];
};

export type WorkflowJob = {
  __typename?: 'WorkflowJob';
  activity: Activity;
  children: Array<WorkflowExecutionId>;
  collection?: Maybe<Collection>;
  collectionId?: Maybe<Scalars['String']['output']>;
  completedChildren: Array<WorkflowExecutionId>;
  context?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  failedChildren: Array<WorkflowExecutionId>;
  id: WorkflowJobId;
  metadata?: Maybe<Metadata>;
  metadataVersion?: Maybe<Scalars['Int']['output']>;
  models: Array<WorkflowActivityModel>;
  parent?: Maybe<WorkflowJobId>;
  planId: WorkflowExecutionId;
  profile?: Maybe<Profile>;
  prompts: Array<WorkflowActivityPrompt>;
  storageSystems: Array<WorkflowActivityStorageSystem>;
  supplementaryId?: Maybe<Scalars['String']['output']>;
  workflow: Workflow;
  workflowActivity: WorkflowActivity;
};

export type WorkflowJobId = {
  __typename?: 'WorkflowJobId';
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  queue: Scalars['String']['output'];
};

export type WorkflowJobIdInput = {
  id: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  queue: Scalars['String']['input'];
};

export type WorkflowSchedule = {
  __typename?: 'WorkflowSchedule';
  attributes?: Maybe<Scalars['JSON']['output']>;
  collection?: Maybe<Collection>;
  configuration?: Maybe<Scalars['JSON']['output']>;
  enabled: Scalars['Boolean']['output'];
  ends?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  lastRun?: Maybe<Scalars['DateTime']['output']>;
  lastScheduled?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Metadata>;
  nextRun?: Maybe<Scalars['DateTime']['output']>;
  rrule: Scalars['String']['output'];
  starts: Scalars['DateTime']['output'];
  workflow?: Maybe<Workflow>;
};

export type WorkflowScheduleInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  enabled: Scalars['Boolean']['input'];
  ends?: InputMaybe<Scalars['DateTime']['input']>;
  rrule: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type WorkflowSchedules = {
  __typename?: 'WorkflowSchedules';
  all: Array<WorkflowSchedule>;
};

export type WorkflowSchedulesMutation = {
  __typename?: 'WorkflowSchedulesMutation';
  add?: Maybe<WorkflowSchedule>;
  delete: Scalars['Boolean']['output'];
};


export type WorkflowSchedulesMutationAddArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  schedule: WorkflowScheduleInput;
};


export type WorkflowSchedulesMutationDeleteArgs = {
  id: Scalars['String']['input'];
};

export type WorkflowState = {
  __typename?: 'WorkflowState';
  configuration?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  entryWorkflowId?: Maybe<Scalars['String']['output']>;
  exitWorkflowId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: WorkflowStateType;
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type WorkflowStateInput = {
  configuration: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  entryWorkflowId?: InputMaybe<Scalars['String']['input']>;
  exitWorkflowId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: WorkflowStateType;
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowStateType {
  Approval = 'APPROVAL',
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED'
}

export type WorkflowStates = {
  __typename?: 'WorkflowStates';
  all: Array<WorkflowState>;
  state?: Maybe<WorkflowState>;
};


export type WorkflowStatesStateArgs = {
  id: Scalars['String']['input'];
};

export type WorkflowStatesMutation = {
  __typename?: 'WorkflowStatesMutation';
  add?: Maybe<WorkflowState>;
  delete: Scalars['Boolean']['output'];
  edit?: Maybe<WorkflowState>;
};


export type WorkflowStatesMutationAddArgs = {
  state: WorkflowStateInput;
};


export type WorkflowStatesMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type WorkflowStatesMutationEditArgs = {
  state: WorkflowStateInput;
};

export type Workflows = {
  __typename?: 'Workflows';
  activities: Activities;
  all: Array<Workflow>;
  executionPlan?: Maybe<WorkflowExecutionPlan>;
  executions: Array<WorkflowExecution>;
  models: Models;
  nextJob?: Maybe<WorkflowJob>;
  prompts: Prompts;
  schedules: WorkflowSchedules;
  states: WorkflowStates;
  storageSystems: StorageSystems;
  testPlan?: Maybe<WorkflowExecutionPlan>;
  traits: Traits;
  transitions: Transitions;
  workflow?: Maybe<Workflow>;
  workflowActivity?: Maybe<WorkflowActivity>;
};


export type WorkflowsExecutionPlanArgs = {
  id: Scalars['String']['input'];
  queue: Scalars['String']['input'];
};


export type WorkflowsExecutionsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  queue: Scalars['String']['input'];
};


export type WorkflowsNextJobArgs = {
  queue: Scalars['String']['input'];
};


export type WorkflowsTestPlanArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  configurations?: InputMaybe<Array<WorkflowConfigurationInput>>;
  delayUntil?: InputMaybe<Scalars['DateTime']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  metadataVersion?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  storageSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  traitId?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
};


export type WorkflowsWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type WorkflowsWorkflowActivityArgs = {
  id: Scalars['Int']['input'];
};

export type WorkflowsMutation = {
  __typename?: 'WorkflowsMutation';
  activities: ActivitiesMutation;
  add: Workflow;
  beginTransition: Scalars['Boolean']['output'];
  cancelTransition: Scalars['Boolean']['output'];
  cancelWorkflows: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  edit: Workflow;
  enqueueChildWorkflow: WorkflowExecutionId;
  enqueueChildWorkflows: Array<WorkflowExecutionId>;
  enqueueWorkflow: WorkflowExecutionId;
  expireAll: Scalars['Boolean']['output'];
  findAndEnqueueWorkflow: Array<WorkflowExecutionId>;
  models: ModelsMutation;
  prompts: PromptsMutation;
  retryAllFailed: Scalars['Boolean']['output'];
  schedules: WorkflowSchedulesMutation;
  setExecutionPlanContext: Scalars['Boolean']['output'];
  setExecutionPlanJobCheckin: Scalars['Boolean']['output'];
  setExecutionPlanJobComplete: Scalars['Boolean']['output'];
  setExecutionPlanJobContext: Scalars['Boolean']['output'];
  setExecutionPlanJobDelayed: Scalars['Boolean']['output'];
  setExecutionPlanJobFailed: Scalars['Boolean']['output'];
  states: WorkflowStatesMutation;
  storageSystems: StorageSystemsMutation;
  traits: TraitsMutation;
  transitions: TransitionsMutation;
};


export type WorkflowsMutationAddArgs = {
  workflow: WorkflowInput;
};


export type WorkflowsMutationBeginTransitionArgs = {
  configurations?: InputMaybe<Array<WorkflowConfigurationInput>>;
  request: BeginTransitionInput;
};


export type WorkflowsMutationCancelTransitionArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  metadataVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkflowsMutationCancelWorkflowsArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  metadataVersion?: InputMaybe<Scalars['Int']['input']>;
  workflowId: Scalars['String']['input'];
};


export type WorkflowsMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type WorkflowsMutationEditArgs = {
  workflow: WorkflowInput;
};


export type WorkflowsMutationEnqueueChildWorkflowArgs = {
  configurations?: InputMaybe<Array<WorkflowConfigurationInput>>;
  delayUntil?: InputMaybe<Scalars['DateTime']['input']>;
  jobId: WorkflowJobIdInput;
  workflowId: Scalars['String']['input'];
};


export type WorkflowsMutationEnqueueChildWorkflowsArgs = {
  delayUntil?: InputMaybe<Scalars['DateTime']['input']>;
  jobId: WorkflowJobIdInput;
  workflowIds: Array<Scalars['String']['input']>;
};


export type WorkflowsMutationEnqueueWorkflowArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  configurations?: InputMaybe<Array<WorkflowConfigurationInput>>;
  delayUntil?: InputMaybe<Scalars['DateTime']['input']>;
  metadataId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  workflowId: Scalars['String']['input'];
};


export type WorkflowsMutationFindAndEnqueueWorkflowArgs = {
  configurations?: InputMaybe<Array<WorkflowConfigurationInput>>;
  delayUntil?: InputMaybe<Scalars['DateTime']['input']>;
  query: FindQueryInput;
  workflowId: Scalars['String']['input'];
};


export type WorkflowsMutationSetExecutionPlanContextArgs = {
  context: Scalars['JSON']['input'];
  planId: WorkflowExecutionIdInput;
};


export type WorkflowsMutationSetExecutionPlanJobCheckinArgs = {
  jobId: WorkflowJobIdInput;
};


export type WorkflowsMutationSetExecutionPlanJobCompleteArgs = {
  jobId: WorkflowJobIdInput;
};


export type WorkflowsMutationSetExecutionPlanJobContextArgs = {
  context: Scalars['JSON']['input'];
  jobId: WorkflowJobIdInput;
};


export type WorkflowsMutationSetExecutionPlanJobDelayedArgs = {
  delayedUntil: Scalars['DateTime']['input'];
  jobId: WorkflowJobIdInput;
};


export type WorkflowsMutationSetExecutionPlanJobFailedArgs = {
  error: Scalars['String']['input'];
  jobId: WorkflowJobIdInput;
  tryAgain: Scalars['Boolean']['input'];
};

export type AddBookmarkMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type AddBookmarkMutation = { __typename?: 'Mutation', profiles: { __typename?: 'ProfilesMutation', profile: { __typename?: 'ProfileMutation', addBookmark: boolean } } };

export type AddPersistedQueriesMutationVariables = Exact<{
  application: Scalars['String']['input'];
  queries: Array<PersistedQueryInput> | PersistedQueryInput;
}>;


export type AddPersistedQueriesMutation = { __typename?: 'Mutation', persistedQueries: { __typename?: 'PersistedQueriesMutation', addAll: boolean } };

export type AddProgressMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  stepId: Scalars['Int']['input'];
}>;


export type AddProgressMutation = { __typename?: 'Mutation', profiles: { __typename?: 'ProfilesMutation', profile: { __typename?: 'ProfileMutation', addProgress?: { __typename?: 'ProfileGuideProgress', started: any, nextStepId?: number | null } | null } } };

export type EditPasswordMutationVariables = Exact<{
  identifier?: InputMaybe<Scalars['String']['input']>;
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type EditPasswordMutation = { __typename?: 'Mutation', security: { __typename?: 'SecurityMutation', principal: { __typename?: 'PrincipalMutation', password: boolean } } };

export type EditPasswordIdentifierMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type EditPasswordIdentifierMutation = { __typename?: 'Mutation', security: { __typename?: 'SecurityMutation', principal: { __typename?: 'PrincipalMutation', identifier: boolean } } };

export type EditProfileMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  profile: ProfileInput;
}>;


export type EditProfileMutation = { __typename?: 'Mutation', profiles: { __typename?: 'ProfilesMutation', edit?: { __typename?: 'Profile', id: string } | null } };

export type ForgotPasswordMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', security: { __typename?: 'SecurityMutation', login: { __typename?: 'LoginMutation', forgotPassword: boolean } } };

export type GetBookmarkQueryVariables = Exact<{
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type GetBookmarkQuery = { __typename?: 'Query', profiles: { __typename?: 'Profiles', current?: { __typename?: 'Profile', bookmarks: { __typename?: 'ProfileBookmarks', bookmark?: { __typename?: 'ProfileBookmark', id: number } | null } } | null } };

export type GetBookmarksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookmarksQuery = { __typename?: 'Query', profiles: { __typename?: 'Profiles', current?: { __typename?: 'Profile', bookmarks: { __typename?: 'ProfileBookmarks', count: number, bookmarks: Array<{ __typename?: 'ProfileBookmark', metadata?: { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null } | null, collection?: { __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | null }> } } | null } };

export type GetCollectionCollectionItemsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetCollectionCollectionItemsQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename: 'Collection', collectionsCount: number, id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, collections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> }>, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename: 'Metadata' } | { __typename: 'Profile' } | null } };

export type GetCollectionExpandedItemsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  state: Scalars['String']['input'];
}>;


export type GetCollectionExpandedItemsQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename: 'Collection', expandedMetadataCount: number, id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, expandedMetadata: Array<{ __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null }>, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename: 'Metadata' } | { __typename: 'Profile' } | null } };

export type GetContentBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetContentBySlugQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number, steps: Array<{ __typename?: 'GuideStep', id: number }> } | null } | { __typename: 'Profile', id: string, slug?: string | null, name: string, visibility: ProfileVisibility, principal?: { __typename?: 'Principal', id: string, verified: boolean } | null, profileAttributes: Array<{ __typename?: 'ProfileAttribute', id: string, typeId: string, visibility: ProfileVisibility, attributes?: any | null, metadata?: { __typename?: 'Metadata', id: string, content: { __typename?: 'MetadataContent', urls: { __typename?: 'MetadataContentUrls', download: { __typename?: 'SignedUrl', url: string, headers: Array<{ __typename?: 'SignedUrlHeader', name: string, value: string }> } } } } | null }> } | null } };

export type GetContentItemsBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetContentItemsBySlugQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename: 'Collection', itemsCount: number, id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, items: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null }>, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename?: 'Metadata' } | { __typename?: 'Profile' } | null } };

export type GetCurrentPrincipalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentPrincipalQuery = { __typename?: 'Query', security: { __typename?: 'Security', principal: { __typename?: 'Principal', id: string, verified: boolean } } };

export type GetCurrentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentProfileQuery = { __typename?: 'Query', profiles: { __typename?: 'Profiles', current?: { __typename: 'Profile', id: string, slug?: string | null, name: string, visibility: ProfileVisibility, principal?: { __typename?: 'Principal', id: string, verified: boolean } | null, profileAttributes: Array<{ __typename?: 'ProfileAttribute', id: string, typeId: string, visibility: ProfileVisibility, attributes?: any | null, metadata?: { __typename?: 'Metadata', id: string, content: { __typename?: 'MetadataContent', urls: { __typename?: 'MetadataContentUrls', download: { __typename?: 'SignedUrl', url: string, headers: Array<{ __typename?: 'SignedUrlHeader', name: string, value: string }> } } } } | null }> } | null } };

export type GetDailyDayQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type GetDailyDayQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename?: 'Collection' } | { __typename?: 'Metadata', id: string, slug?: string | null, name: string, attributes?: any | null, guide?: { __typename?: 'Guide', step?: { __typename?: 'GuideStep', date?: any | null, metadata?: { __typename?: 'Metadata', id: string, slug?: string | null, name: string, attributes?: any | null, document?: { __typename?: 'Document', title: string, content: any } | null, relationships: Array<{ __typename?: 'MetadataRelationship', relationship: string, metadata: { __typename?: 'Metadata', id: string, attributes?: any | null } }> } | null } | null } | null } | { __typename?: 'Profile' } | null } };

export type GetDailyStepQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}>;


export type GetDailyStepQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename?: 'Collection' } | { __typename?: 'Metadata', id: string, slug?: string | null, name: string, attributes?: any | null, guide?: { __typename?: 'Guide', step?: { __typename?: 'GuideStep', date?: any | null, metadata?: { __typename?: 'Metadata', id: string, slug?: string | null, name: string, attributes?: any | null, document?: { __typename?: 'Document', title: string, content: any } | null, relationships: Array<{ __typename?: 'MetadataRelationship', relationship: string, metadata: { __typename?: 'Metadata', id: string, attributes?: any | null } }> } | null } | null } | null } | { __typename?: 'Profile' } | null } };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', content: { __typename?: 'Content', metadata?: { __typename?: 'Metadata', document?: { __typename: 'Document', title: string, content: any } | null } | null } };

export type GetItemsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetItemsQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename: 'Collection', itemsCount: number, id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, items: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null }>, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename: 'Metadata' } | { __typename: 'Profile' } | null } };

export type GetBibleMetadataChapterQueryVariables = Exact<{
  id: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
  usfm: Scalars['String']['input'];
}>;


export type GetBibleMetadataChapterQuery = { __typename?: 'Query', content: { __typename?: 'Content', metadata?: { __typename?: 'Metadata', bible?: { __typename?: 'Bible', chapter?: { __typename?: 'BibleChapter', usfm: string, human: string, component: any, reference: { __typename?: 'BibleReference', human: string, usfm: string } } | null } | null } | null } };

export type GetProgressionQueryVariables = Exact<{
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type GetProgressionQuery = { __typename?: 'Query', profiles: { __typename?: 'Profiles', current?: { __typename?: 'Profile', guides: { __typename?: 'ProfileGuides', progressions: { __typename?: 'ProfileGuideProgressions', progress?: { __typename?: 'ProfileGuideProgress', percentage: number, started: any, completedStepIds: Array<number>, nextStepId?: number | null } | null } } } | null } };

export type GetProgressionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgressionsQuery = { __typename?: 'Query', profiles: { __typename?: 'Profiles', current?: { __typename?: 'Profile', guides: { __typename?: 'ProfileGuides', progressions: { __typename?: 'ProfileGuideProgressions', all: Array<{ __typename?: 'ProfileGuideProgress', nextStepId?: number | null, percentage: number, started: any, metadata: { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null } }> } } } | null } };

export type GetStudyDayQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  dayOffset: Scalars['Int']['input'];
}>;


export type GetStudyDayQuery = { __typename?: 'Query', content: { __typename?: 'Content', slug?: { __typename?: 'Collection' } | { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, guide?: { __typename?: 'Guide', stepCount: number, stepByOffset?: { __typename?: 'GuideStep', metadata?: { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null } | null } | null, steps: Array<{ __typename?: 'GuideStep', id: number }> } | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> } | { __typename?: 'Profile' } | null } };

export type LoginMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', security: { __typename?: 'SecurityMutation', login: { __typename?: 'LoginMutation', password: { __typename?: 'LoginResponse', profile?: { __typename: 'Profile', id: string, slug?: string | null, name: string, visibility: ProfileVisibility, principal?: { __typename?: 'Principal', id: string, verified: boolean } | null, profileAttributes: Array<{ __typename?: 'ProfileAttribute', id: string, typeId: string, visibility: ProfileVisibility, attributes?: any | null, metadata?: { __typename?: 'Metadata', id: string, content: { __typename?: 'MetadataContent', urls: { __typename?: 'MetadataContentUrls', download: { __typename?: 'SignedUrl', url: string, headers: Array<{ __typename?: 'SignedUrlHeader', name: string, value: string }> } } } } | null }> } | null, principal: { __typename?: 'Principal', id: string, groups: Array<{ __typename?: 'Group', id: string, name: string }> }, token: { __typename?: 'Token', token: string } } } } };

export type NewsletterSignupMutationVariables = Exact<{
  profile: ProfileInput;
}>;


export type NewsletterSignupMutation = { __typename?: 'Mutation', profiles: { __typename?: 'ProfilesMutation', add?: { __typename: 'Profile', id: string, slug?: string | null, name: string, visibility: ProfileVisibility, principal?: { __typename?: 'Principal', id: string, verified: boolean } | null, profileAttributes: Array<{ __typename?: 'ProfileAttribute', id: string, typeId: string, visibility: ProfileVisibility, attributes?: any | null, metadata?: { __typename?: 'Metadata', id: string, content: { __typename?: 'MetadataContent', urls: { __typename?: 'MetadataContentUrls', download: { __typename?: 'SignedUrl', url: string, headers: Array<{ __typename?: 'SignedUrlHeader', name: string, value: string }> } } } } | null }> } | null } };

export type RemoveBookmarkMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type RemoveBookmarkMutation = { __typename?: 'Mutation', profiles: { __typename?: 'ProfilesMutation', profile: { __typename?: 'ProfileMutation', deleteBookmark: boolean } } };

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  filter: Scalars['String']['input'];
  sort?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'SearchResultObject', estimatedHits: number, documents: Array<{ __typename?: 'SearchDocument', metadata?: { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null } | null, collection?: { __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | null, profile?: { __typename: 'Profile', id: string, slug?: string | null, name: string, visibility: ProfileVisibility, principal?: { __typename?: 'Principal', id: string, verified: boolean } | null, profileAttributes: Array<{ __typename?: 'ProfileAttribute', id: string, typeId: string, visibility: ProfileVisibility, attributes?: any | null, metadata?: { __typename?: 'Metadata', id: string, content: { __typename?: 'MetadataContent', urls: { __typename?: 'MetadataContentUrls', download: { __typename?: 'SignedUrl', url: string, headers: Array<{ __typename?: 'SignedUrlHeader', name: string, value: string }> } } } } | null }> } | null }>, facets: Array<{ __typename?: 'SearchResultFacet', field: string, value: string, count: number }> } };

export type SignUpMutationVariables = Exact<{
  profile: ProfileInput;
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SignUpMutation = { __typename?: 'Mutation', security: { __typename?: 'SecurityMutation', signup: { __typename?: 'SignupMutation', password: { __typename?: 'Principal', id: string } } } };

export type VerifySignUpMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifySignUpMutation = { __typename?: 'Mutation', security: { __typename?: 'SecurityMutation', signup: { __typename?: 'SignupMutation', passwordVerify: boolean } } };

export type BibleFragment = { __typename?: 'Bible', systemId: string, name: string, nameLocal: string, description: string, abbreviation: string, abbreviationLocal: string, styles: any, languages: Array<{ __typename?: 'BibleLanguage', iso: string, name: string, nameLocal: string, script: string, scriptCode: string, scriptDirection: string }> };

export type BibleBookFragment = { __typename?: 'BibleBook', usfm: string, nameShort: string, nameLong: string, abbreviation: string };

export type BibleBookWithChaptersFragment = { __typename?: 'BibleBook', usfm: string, nameShort: string, nameLong: string, abbreviation: string, chapters: Array<{ __typename?: 'BibleChapter', usfm: string }> };

export type BibleChapterFragment = { __typename?: 'BibleChapter', usfm: string };

export type BibleChapterContentFragment = { __typename?: 'BibleChapter', usfm: string, human: string, component: any, reference: { __typename?: 'BibleReference', human: string, usfm: string } };

export type BibleReferenceFragment = { __typename?: 'BibleReference', usfm: string, human: string };

export type BibleLanguageFragment = { __typename?: 'BibleLanguage', iso: string, name: string, nameLocal: string, script: string, scriptCode: string, scriptDirection: string };

export type CollectionListFragment = { __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, items: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> } | { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null }>, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> };

export type CollectionFragment = { __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, created: any, modified: any, attributes?: any | null, collectionType: CollectionType, allItemsCount: number, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }> };

export type CollectionMetadataRelationshipFragment = { __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } };

export type DocumentFragment = { __typename: 'Document', title: string, content: any };

export type MetadataFragment = { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number } | null };

export type MetadataRelationshipFragment = { __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } };

export type MetadataWithStepIdsFragment = { __typename: 'Metadata', id: string, slug?: string | null, version: number, name: string, languageTag: string, parentId?: string | null, type: MetadataType, created: any, modified: any, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string }, parentCollections: Array<{ __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> }>, relationships: Array<{ __typename: 'MetadataRelationship', relationship: string, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }>, guide?: { __typename?: 'Guide', stepCount: number, steps: Array<{ __typename?: 'GuideStep', id: number }> } | null };

export type ParentCollectionFragment = { __typename: 'Collection', id: string, slug?: string | null, name: string, description?: string | null, attributes?: any | null, metadataRelationships: Array<{ __typename: 'CollectionMetadataRelationship', relationship?: string | null, attributes?: any | null, metadata: { __typename: 'Metadata', id: string, slug?: string | null, attributes?: any | null, content: { __typename?: 'MetadataContent', type: string } } }> };

export type PrincipalFragment = { __typename?: 'Principal', id: string, verified: boolean };

export type ProfileIdNameFragment = { __typename: 'Profile', id: string, name: string };

export type ProfileFragment = { __typename: 'Profile', id: string, slug?: string | null, name: string, visibility: ProfileVisibility, principal?: { __typename?: 'Principal', id: string, verified: boolean } | null, profileAttributes: Array<{ __typename?: 'ProfileAttribute', id: string, typeId: string, visibility: ProfileVisibility, attributes?: any | null, metadata?: { __typename?: 'Metadata', id: string, content: { __typename?: 'MetadataContent', urls: { __typename?: 'MetadataContentUrls', download: { __typename?: 'SignedUrl', url: string, headers: Array<{ __typename?: 'SignedUrlHeader', name: string, value: string }> } } } } | null }> };

export type ProgressionFragment = { __typename?: 'ProfileGuideProgress', percentage: number, started: any, completedStepIds: Array<number>, nextStepId?: number | null };

export const BibleLanguageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleLanguage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleLanguage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iso"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameLocal"}},{"kind":"Field","name":{"kind":"Name","value":"script"}},{"kind":"Field","name":{"kind":"Name","value":"scriptCode"}},{"kind":"Field","name":{"kind":"Name","value":"scriptDirection"}}]}}]} as unknown as DocumentNode<BibleLanguageFragment, unknown>;
export const BibleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Bible"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Bible"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameLocal"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviationLocal"}},{"kind":"Field","name":{"kind":"Name","value":"styles"}},{"kind":"Field","name":{"kind":"Name","value":"languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BibleLanguage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleLanguage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleLanguage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iso"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameLocal"}},{"kind":"Field","name":{"kind":"Name","value":"script"}},{"kind":"Field","name":{"kind":"Name","value":"scriptCode"}},{"kind":"Field","name":{"kind":"Name","value":"scriptDirection"}}]}}]} as unknown as DocumentNode<BibleFragment, unknown>;
export const BibleBookFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleBook"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleBook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usfm"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]} as unknown as DocumentNode<BibleBookFragment, unknown>;
export const BibleChapterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleChapter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleChapter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usfm"}}]}}]} as unknown as DocumentNode<BibleChapterFragment, unknown>;
export const BibleBookWithChaptersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleBookWithChapters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleBook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BibleBook"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BibleChapter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleBook"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleBook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usfm"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleChapter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleChapter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usfm"}}]}}]} as unknown as DocumentNode<BibleBookWithChaptersFragment, unknown>;
export const BibleChapterContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleChapterContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleChapter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usfm"}},{"kind":"Field","name":{"kind":"Name","value":"human"}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"human"}},{"kind":"Field","name":{"kind":"Name","value":"usfm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"component"}}]}}]} as unknown as DocumentNode<BibleChapterContentFragment, unknown>;
export const BibleReferenceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usfm"}},{"kind":"Field","name":{"kind":"Name","value":"human"}}]}}]} as unknown as DocumentNode<BibleReferenceFragment, unknown>;
export const CollectionMetadataRelationshipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]} as unknown as DocumentNode<CollectionMetadataRelationshipFragment, unknown>;
export const ParentCollectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]} as unknown as DocumentNode<ParentCollectionFragment, unknown>;
export const CollectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}}]} as unknown as DocumentNode<CollectionFragment, unknown>;
export const MetadataRelationshipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]} as unknown as DocumentNode<MetadataRelationshipFragment, unknown>;
export const MetadataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]} as unknown as DocumentNode<MetadataFragment, unknown>;
export const CollectionListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}}]} as unknown as DocumentNode<CollectionListFragment, unknown>;
export const DocumentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Document"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]} as unknown as DocumentNode<DocumentFragment, unknown>;
export const MetadataWithStepIdsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataWithStepIds"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]} as unknown as DocumentNode<MetadataWithStepIdsFragment, unknown>;
export const PrincipalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Principal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Principal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]} as unknown as DocumentNode<PrincipalFragment, unknown>;
export const ProfileIdNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileIdName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ProfileIdNameFragment, unknown>;
export const ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","alias":{"kind":"Name","value":"profileAttributes"},"name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileFragment, unknown>;
export const ProgressionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Progression"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileGuideProgress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"started"}},{"kind":"Field","name":{"kind":"Name","value":"completedStepIds"}},{"kind":"Field","name":{"kind":"Name","value":"nextStepId"}}]}}]} as unknown as DocumentNode<ProgressionFragment, unknown>;
export const AddBookmarkDocument = {"__meta__":{"hash":"4a3ae4846675e0e238d342928bc11d90d357976e"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddBookmark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addBookmark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"metadataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}]}]}}]}}]}}]} as unknown as DocumentNode<AddBookmarkMutation, AddBookmarkMutationVariables>;
export const AddPersistedQueriesDocument = {"__meta__":{"hash":"c9f58ba27dc5b3d5f6fdd34bebccfe6a831b530e"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPersistedQueries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"application"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queries"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersistedQueryInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"persistedQueries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"application"},"value":{"kind":"Variable","name":{"kind":"Name","value":"application"}}},{"kind":"Argument","name":{"kind":"Name","value":"queries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queries"}}}]}]}}]}}]} as unknown as DocumentNode<AddPersistedQueriesMutation, AddPersistedQueriesMutationVariables>;
export const AddProgressDocument = {"__meta__":{"hash":"c68152f8c3939ba988b2a4c5a4a0b987f740ac2e"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stepId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"metadataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"metadataVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"stepId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stepId"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"started"}},{"kind":"Field","name":{"kind":"Name","value":"nextStepId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddProgressMutation, AddProgressMutationVariables>;
export const EditPasswordDocument = {"__meta__":{"hash":"a91e23c26c6c0c20e9b2723c9b967bdd48f1932d"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"password"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}}]}]}}]}}]}}]} as unknown as DocumentNode<EditPasswordMutation, EditPasswordMutationVariables>;
export const EditPasswordIdentifierDocument = {"__meta__":{"hash":"014a384dbc1d4bf8f37038a60cce0788b5d774c9"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPasswordIdentifier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}}]}]}}]}}]}}]} as unknown as DocumentNode<EditPasswordIdentifierMutation, EditPasswordIdentifierMutationVariables>;
export const EditProfileDocument = {"__meta__":{"hash":"4a1b490959c4d50067aaf5979f45c538b8bc33d3"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EditProfileMutation, EditProfileMutationVariables>;
export const ForgotPasswordDocument = {"__meta__":{"hash":"4ef5d03c4de1444e0cf958914b7a43cf70e95e98"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ForgotPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}}]}]}}]}}]}}]} as unknown as DocumentNode<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetBookmarkDocument = {"__meta__":{"hash":"f16296f2575651bb8991a44139299973ec799cb3"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookmark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookmark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"metadataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"metadataVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBookmarkQuery, GetBookmarkQueryVariables>;
export const GetBookmarksDocument = {"__meta__":{"hash":"4a81b44efe4b5407dd952f2b04a72e6002ee9d22"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"bookmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}}]} as unknown as DocumentNode<GetBookmarksQuery, GetBookmarksQueryVariables>;
export const GetCollectionCollectionItemsDocument = {"__meta__":{"hash":"27d5f2605a2e48dccf8633729412625ae8c6a796"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionCollectionItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionsCount"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}}]} as unknown as DocumentNode<GetCollectionCollectionItemsQuery, GetCollectionCollectionItemsQueryVariables>;
export const GetCollectionExpandedItemsDocument = {"__meta__":{"hash":"5ff517153728846be876a9d8bb14a057471e2257"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionExpandedItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}},{"kind":"Field","name":{"kind":"Name","value":"expandedMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expandedMetadataCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}}]} as unknown as DocumentNode<GetCollectionExpandedItemsQuery, GetCollectionExpandedItemsQueryVariables>;
export const GetContentBySlugDocument = {"__meta__":{"hash":"9fdd94bd60353aaec63139729ad79fcaef86d17a"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContentBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataWithStepIds"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Profile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataWithStepIds"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","alias":{"kind":"Name","value":"profileAttributes"},"name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetContentBySlugQuery, GetContentBySlugQueryVariables>;
export const GetContentItemsBySlugDocument = {"__meta__":{"hash":"a009668f11604a7569e454a7c311d1a9486c1fca"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContentItemsBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemsCount"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}}]} as unknown as DocumentNode<GetContentItemsBySlugQuery, GetContentItemsBySlugQueryVariables>;
export const GetCurrentPrincipalDocument = {"__meta__":{"hash":"04e28131fe386ffb89a2b878d1dcf20c166f0e3f"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentPrincipal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Principal"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Principal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Principal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]} as unknown as DocumentNode<GetCurrentPrincipalQuery, GetCurrentPrincipalQueryVariables>;
export const GetCurrentProfileDocument = {"__meta__":{"hash":"59104d35353aed533c4e2210edfeb645c327d67e"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Profile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","alias":{"kind":"Name","value":"profileAttributes"},"name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentProfileQuery, GetCurrentProfileQueryVariables>;
export const GetDailyDayDocument = {"__meta__":{"hash":"326f238c2078b912fe60476bcd259b3c37a11402"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDailyDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"step"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDailyDayQuery, GetDailyDayQueryVariables>;
export const GetDailyStepDocument = {"__meta__":{"hash":"2ff587a9fc0e040e92c74281cbaadf0475879b4a"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDailyStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"step"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stepId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDailyStepQuery, GetDailyStepQueryVariables>;
export const GetDocumentDocument = {"__meta__":{"hash":"91f80eafba7d5b5cce6f5c7036cc5f6d54a3fad8"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Document"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Document"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]} as unknown as DocumentNode<GetDocumentQuery, GetDocumentQueryVariables>;
export const GetItemsDocument = {"__meta__":{"hash":"45787736b008fd21541a363fdcb1e969e9156b06"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}}]} as unknown as DocumentNode<GetItemsQuery, GetItemsQueryVariables>;
export const GetBibleMetadataChapterDocument = {"__meta__":{"hash":"e0bb0f27b57214e299e3fc845379230f5e2a3860"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBibleMetadataChapter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usfm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"usfm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usfm"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BibleChapterContent"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BibleChapterContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BibleChapter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usfm"}},{"kind":"Field","name":{"kind":"Name","value":"human"}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"human"}},{"kind":"Field","name":{"kind":"Name","value":"usfm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"component"}}]}}]} as unknown as DocumentNode<GetBibleMetadataChapterQuery, GetBibleMetadataChapterQueryVariables>;
export const GetProgressionDocument = {"__meta__":{"hash":"4de961101b0f085b59d0c10d5efeb1f1a3e1c767"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProgression"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progressions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Progression"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Progression"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileGuideProgress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"started"}},{"kind":"Field","name":{"kind":"Name","value":"completedStepIds"}},{"kind":"Field","name":{"kind":"Name","value":"nextStepId"}}]}}]} as unknown as DocumentNode<GetProgressionQuery, GetProgressionQueryVariables>;
export const GetProgressionsDocument = {"__meta__":{"hash":"8a37e574e05a396d0a98c5acb4c4430900dc2c83"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProgressions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progressions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"all"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextStepId"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"started"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}}]} as unknown as DocumentNode<GetProgressionsQuery, GetProgressionsQueryVariables>;
export const GetStudyDayDocument = {"__meta__":{"hash":"03a7787374da43320eba28065b4f6f3b08b19e15"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudyDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayOffset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepByOffset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayOffset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}}]} as unknown as DocumentNode<GetStudyDayQuery, GetStudyDayQueryVariables>;
export const LoginDocument = {"__meta__":{"hash":"dbe1eb79c035db8c6dc02ae1c77ca71ffb0b23dc"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"password"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Profile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","alias":{"kind":"Name","value":"profileAttributes"},"name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const NewsletterSignupDocument = {"__meta__":{"hash":"057e5d66a09eaf9a8662238939206ed26c59af13"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewsletterSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"add"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Profile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","alias":{"kind":"Name","value":"profileAttributes"},"name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsletterSignupMutation, NewsletterSignupMutationVariables>;
export const RemoveBookmarkDocument = {"__meta__":{"hash":"2106f1fc322d1e8069fe5890e6bd9c93e33e395b"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveBookmark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBookmark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"metadataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}]}]}}]}}]}}]} as unknown as DocumentNode<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;
export const SearchDocument = {"__meta__":{"hash":"f3e4f4c78fcc2a8cb257f25245ae006f0fa25ec2"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"storageSystemName"},"value":{"kind":"StringValue","value":"Public Search Index","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"facets"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"authors.id","block":false},{"kind":"StringValue","value":"topics.id","block":false},{"kind":"StringValue","value":"type","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Collection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Profile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHits"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionMetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetadataRelationship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataRelationship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"collectionType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","alias":{"kind":"Name","value":"allItemsCount"},"name":{"kind":"Name","value":"itemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadataRelationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionMetadataRelationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","alias":{"kind":"Name","value":"profileAttributes"},"name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
export const SignUpDocument = {"__meta__":{"hash":"2b752bb563da8531229f20469b38788335daed98"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"password"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile"}}},{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SignUpMutation, SignUpMutationVariables>;
export const VerifySignUpDocument = {"__meta__":{"hash":"ef2592134a686b7148d4fcdd5ecb0db3b104717c"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifySignUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passwordVerify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"verificationToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]}}]}}]} as unknown as DocumentNode<VerifySignUpMutation, VerifySignUpMutationVariables>;